import { atom } from "recoil";

export const snackbarState = atom({
    key: 'snackbarState',
    default: null
});